const seenFeatureStorageKeyPrefix = "enit-hub-seen-feature:";

function storageKey(featureId: string): string {
  return `${seenFeatureStorageKeyPrefix}${featureId}`;
}

export const SeenFeatureService = {
  hasSeen(featureId: string): boolean {
    return localStorage.getItem(storageKey(featureId)) != null;
  },

  markAsSeen(featureId: string): void {
    localStorage.setItem(storageKey(featureId), new Date().toISOString());
  },

  isStillAnnounced(showUntil: Date): boolean {
    return showUntil.getTime() > Date.now();
  },
};
